import {Capability} from "../formElementCapability";
import IFormElementSchema from "./iFormElementSchema";
import {FormElementType} from "~/enums/formElementType";
import {generateDropdownItemRestrictions, baseDropdownItemRestrictions} from "./schemaHelper";
import {InputFormatType} from "../../inputFormatType";
import {stateDropdownItems} from "./stateDropdownSchema";
import {DefaultOptionType} from "../../defaultOptionType";

export const baseRestrictions: Capability[] = [
  Capability.defaultable,
  Capability.maskable,
  Capability.repeatable,
  Capability.lengthable,
  Capability.readonlyable,
  Capability.showHideable,
  Capability.formatable,
  Capability.sortable,
  Capability.destroyable,
  Capability.layoutable,
  Capability.verticalAlign,
  Capability.profileConfig,
  Capability.indexable,
  Capability.requireable,
];

export const restrictionSchema: object = {
  //Pan Validation base element
  self: baseRestrictions,
  children: [
    {
      // Address Line 1
      self: baseRestrictions,
    },
    {
      // Address Line 2
      self: baseRestrictions,
    },
    {
      //Grid Element
      self: [...baseRestrictions, Capability.layoutable, Capability.helpTextable],
      children: [
        {
          //City
          self: baseRestrictions
        },
        {
          // State
          self: [...baseRestrictions, Capability.defaultOption],
          children: generateDropdownItemRestrictions(stateDropdownItems.length, baseDropdownItemRestrictions)
        },
        {
          // Zip Code
          self: baseRestrictions
        }
      ]
    }
  ]
};


export const formElementsSchema: Array<IFormElementSchema> = [
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Address Line 1',
      sort_order: 0,
      is_required: true
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Address Line 2',
      sort_order: 1,
      is_required: false
    }
  },
  {
    formElementType: FormElementType.grid,
    json: {
      layout_config: [1,1,1],
      sort_order: 2
    },
    formElements: [
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: 'City',
          sort_order: 0,
          is_required: true,
        }
      },
      {
        formElementType: FormElementType.dropdown,
        json: {
          label_title: "State",
          is_required: true,
          sort_order: 1,
          default_option_locked: true,
          default_option_type: DefaultOptionType.None
        },
        formElements: stateDropdownItems
      },
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: 'Zip Code',
          sort_order: 2,
          is_required: true,
          format_type: InputFormatType.Zip
        }
      },
    ]
  }
];